<template>
  <div>
    <van-overlay :z-index="999999" :show="this.$store.state.loading" >
      <div class="loading-wrapper" @click.stop>
        <div class="block">
          <div class="coinicon"/>
          <span>正在努力加载...</span>
        </div>
      </div>
    </van-overlay>


    <div class="home">

      <van-dropdown-menu active-color="#FF3C28" class="top-dropdown" v-if="$store.state.currentShowActive !== 'game-list' ">
        <van-dropdown-item
          @change="storeChange"
          v-model="$store.state.storeDropdownValue"
          :options="$store.state.storeDropdownOption" >
        </van-dropdown-item>
      </van-dropdown-menu>


      <van-search
        style="position: fixed;top: 0;left:0;z-index:60;width: 100%;height: 48px;"
        v-if="$store.state.currentShowActive === 'game-list'"
        v-model="$store.state.searching"
        @search="searchBtn"
        @clear="searchCancelBtn"
        shape="round"
        background="#FF3C28"
        placeholder="请输入搜索关键词"
      />


      <div style="height: 48px" />

      <!--    先做个单页-->
      <div class="show-content" v-if="$store.state.currentShowActive === 'show'">
        <Show  />
      </div>

      <div class="price-content" v-if="$store.state.currentShowActive === 'price'">
        <Price />
      </div>

      <div class="map-content" v-if="$store.state.currentShowActive === 'map'">
        <Map/>
      </div>

      <div class="game-list" v-if="$store.state.currentShowActive === 'game-list'">
        <GameList/>
      </div>

      <div class="serve" v-if="$store.state.currentShowActive === 'serve'">
        <Serve />
      </div>

      <Fight />


      <div style="height: 80px" />

      <van-tabbar  class="app-bottom" style="z-index: 900"
                  active-color="#FF3C28" inactive-color="#646566">
        <van-tabbar-item v-for="v in menuList" :name="v.name"  @click="onClickIcon(v.name)">
          <div>
            <img style="text-align:center; width: 30px;" :src="$store.state.currentShowActive === v.name ? v.activeIcon : v.icon" :alt="v.name">
          </div>
          <div style="font-size: 14px;margin-top: 5px" :style="{color: $store.state.currentShowActive === v.name ? '#FF3C28' : '#646566'}">
            {{ v.text }}
          </div>
        </van-tabbar-item>
      </van-tabbar>


<!--      <van-goods-action class="app-bottom" style="z-index: 900">-->
<!--        <template v-for="v in menuList">-->
<!--          <van-goods-action-icon :name="v.name" @click="onClickIcon(v.name)">-->
<!--            <template #icon="props">-->
<!--              <img  :src="$store.state.currentShowActive === v.name ? v.activeIcon : v.icon" :alt="v.name">-->
<!--            </template>-->
<!--            <span :style="$store.state.currentShowActive === v.name ? 'color:#FF3C28' : 'color:#646566'" >{{ v.text }}</span>-->
<!--          </van-goods-action-icon>-->
<!--        </template>-->

<!--&lt;!&ndash;        <van-goods-action-button&ndash;&gt;-->
<!--&lt;!&ndash;          type="danger"&ndash;&gt;-->
<!--&lt;!&ndash;          @click="onClickButton"&ndash;&gt;-->
<!--&lt;!&ndash;        >&ndash;&gt;-->
<!--&lt;!&ndash;          <template #default="props">&ndash;&gt;-->
<!--&lt;!&ndash;          <span style="font-size: 16px;" class="flex-center">&ndash;&gt;-->
<!--&lt;!&ndash;            <img src="@/public/img/wq.png" style="width: 16px;object-fit: contain;margin-right: 5px">&ndash;&gt;-->
<!--&lt;!&ndash;            <span v-if="$store.state.fightData === null">&ndash;&gt;-->
<!--&lt;!&ndash;              立即预约&ndash;&gt;-->
<!--&lt;!&ndash;            </span>&ndash;&gt;-->
<!--&lt;!&ndash;            <span v-else>&ndash;&gt;-->
<!--&lt;!&ndash;              预约信息&ndash;&gt;-->
<!--&lt;!&ndash;            </span>&ndash;&gt;-->
<!--&lt;!&ndash;          </span>&ndash;&gt;-->
<!--&lt;!&ndash;          </template>&ndash;&gt;-->

<!--&lt;!&ndash;        </van-goods-action-button>&ndash;&gt;-->
<!--      </van-goods-action>-->

    </div>
  </div>

</template>


<script>
import {getCookie} from "@/utils/common";
import axios from "@/utils/axios";

export default {
  name: "reservation",
  components: {
    Show: () => import("@/components/Show"),
    Price: () => import("@/components/Price"),
    Map: () => import("@/components/Map"),
    GameList: () => import("@/components/GameList"),
    Fight: () => import("@/components/Fight"),
    Serve: () => import("@/components/Serve"),
  },
  data() {
    return {
      menuList: [
        {
          activeIcon: require("@/public/img/Mario-Mushroom-Active.png"),
          icon:require("@/public/img/Mario-Mushroom.png"),
          text: "包间预约",
          name: "show"
        },
        {
          activeIcon: require("@/public/img/Pacman-Ghost-Active.png"),
          icon: require("@/public/img/Pacman-Ghost.png"),
          text: "价格表",
          name: "price"
        },
        {
          activeIcon: require("@/public/img/Pokemon-Active.png"),
          icon: require("@/public/img/Pokemon.png"),
          text: "指路",
          name: "map"
        },
        {
          activeIcon: require("@/public/img/Game-Console-Active.png"),
          icon: require("@/public/img/Game-Console.png"),
          text: "热门游戏",
          name: "game-list"
        },
        {
          activeIcon: require("@/public/img/Space-Invaders-Active.png"),
          icon: require("@/public/img/Space-Invaders.png"),
          text: "服务",
          name: "serve"
        }
      ],
    }
  },
  created() {
    this.$store.commit("initApp", this.$route);
  },
  mounted() {
    this.storeChange(this.$store.state.storeDropdownValue);
  },
  methods: {
    searchCancelBtn() {
      this.$store.state.searchCancel++;
      this.$store.state.search = "";
    },
    searchBtn(search) {
      this.$store.state.search = search;
    },
    storeChange(item) {
      this.$store.commit("storeChange", item);
    },
    onClickButton() {
      if (this.$store.state.fightData) {
        this.$store.commit("currentFightSpan", this.$store.state.fightData);
      } else {
        this.$store.state.fightShow = true;
      }
    },
    onClickIcon(name) {
      switch (name) {
        case 'show':
          this.$store.commit("getRoomList", this.$store.state.storeDropdownValue)
          break;
      }

      this.$store.state.currentShowActive = name;
    }
  }
}
</script>


<style>
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.loading-wrapper .block {
  width: 120px;
  height: 120px;
  text-align: center;
  color: white;

}

.loading-wrapper .block span {
  display: block;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
}


.loading-wrapper .coinicon {
  display: block;
  background: url("@/public/coin/coin1.png");
  margin: 15px auto 0;
  height: 60px;
  width: 60px;
  animation: coin 2.3s infinite linear;
  background-size: 100% 100%;
}


.van-goods-action-icon {
  font-size: 12px!important;
}

.van-goods-action-icon__icon {
  width: 55px!important;
}

.van-goods-action-icon__icon img {
  width: 25px;
}

.app-bottom {
  height: 60px!important;
  padding-bottom: 20px!important;
  text-align: center;
}

.app-bottom .van-goods-action-icon {
  min-width: 55px;
}

.top-dropdown {
  position: fixed;
  width: 100%;
  z-index: 999;
  top: 0;
  left: 0;
  height: 48px;
}

.top-dropdown .van-dropdown-menu__bar {
  background: linear-gradient(to right, #ff9800, #FF3C28);
}

.top-dropdown .van-ellipsis {
  color: white;
}

.top-dropdown .van-dropdown-menu__title--active {
  color: white!important;
}


.top-dropdown .van-dropdown-menu__title::after {
  border-color: transparent transparent #fff #fff!important;
}



@keyframes coin{
  0%{ background: url('@/public/coin/coin1.png');
    background-size: 100% 100%;}
  2.5%{ background: url('@/public/coin/coin2.png');
    background-size: 100% 100%;}
  5%{ background: url('@/public/coin/coin3.png');
    background-size: 100% 100%;}
  7.5%{ background: url('@/public/coin/coin4.png');
    background-size: 100% 100%;}
  10%{ background: url('@/public/coin/coin5.png');
    background-size: 100% 100%;}
  12.5%{ background: url('@/public/coin/coin6.png');
    background-size: 100% 100%;}
  15%{ background: url('@/public/coin/coin7.png');
    background-size: 100% 100%;}
  17.5%{ background: url('@/public/coin/coin8.png');
    background-size: 100% 100%;}
  20%{ background: url('@/public/coin/coin9.png');
    background-size: 100% 100%;}
  22.5%{ background: url('@/public/coin/coin10.png');
    background-size: 100% 100%;}
  25%{ background: url('@/public/coin/coin11.png');
    background-size: 100% 100%;}
  27.5%{ background: url('@/public/coin/coin12.png');
    background-size: 100% 100%;}
  30%{ background: url('@/public/coin/coin13.png');
    background-size: 100% 100%;}
  32.5%{ background: url('@/public/coin/coin14.png');
    background-size: 100% 100%;}
  35%{ background: url('@/public/coin/coin15.png');
    background-size: 100% 100%;}
  37.5%{ background: url('@/public/coin/coin16.png');
    background-size: 100% 100%;}
  40%{ background: url('@/public/coin/coin17.png');
    background-size: 100% 100%;}
  42.5%{ background: url('@/public/coin/coin18.png');
    background-size: 100% 100%;}
  45%{ background: url('@/public/coin/coin19.png');
    background-size: 100% 100%;}
  47.5%{ background: url('@/public/coin/coin20.png');
    background-size: 100% 100%;}
  50%{ background: url('@/public/coin/coin1.png');
    background-size: 100% 100%;}
  52.5%{ background: url('@/public/coin/coin2.png');
    background-size: 100% 100%;}
  55%{ background: url('@/public/coin/coin3.png');
    background-size: 100% 100%;}
  57.5%{ background: url('@/public/coin/coin4.png');
    background-size: 100% 100%;}
  60%{ background: url('@/public/coin/coin5.png');
    background-size: 100% 100%;}
  62.5%{ background: url('@/public/coin/coin6.png');
    background-size: 100% 100%;}
  65%{ background: url('@/public/coin/coin7.png');
    background-size: 100% 100%;}
  67.5%{ background:url('@/public/coin/coin8.png');
    background-size: 100% 100%;}
  70%{ background: url('@/public/coin/coin9.png');
    background-size: 100% 100%;}
  72.5%{ background: url('@/public/coin/coin10.png');
    background-size: 100% 100%;}
  75%{ background: url('@/public/coin/coin11.png');
    background-size: 100% 100%;}
  77.5%{ background: url('@/public/coin/coin12.png');
    background-size: 100% 100%;}
  80%{ background: url('@/public/coin/coin13.png');
    background-size: 100% 100%;}
  82.5%{ background: url('@/public/coin/coin14.png');
    background-size: 100% 100%;}
  85%{ background: url('@/public/coin/coin15.png');
    background-size: 100% 100%;}
  87.5%{ background: url('@/public/coin/coin16.png');
    background-size: 100% 100%;}
  90%{ background: url('@/public/coin/coin17.png');
    background-size: 100% 100%;}
  92.5%{ background: url('@/public/coin/coin18.png');
    background-size: 100% 100%;}
  95%{ background: url('@/public/coin/coin19.png');
    background-size: 100% 100%;}
  97.5%{ background:url('@/public/coin/coin20.png');
    background-size: 100% 100%;}
  100%{ background: url('@/public/coin/coin1.png');
    background-size: 100% 100%;}

}


</style>
